import React from "react";
import { Node } from "@iventis/domain-model/model/node";
import { BottomUpHierarchy } from "@iventis/domain-model/model/bottomUpHierarchy";
import { TreeBrowserStateInterface } from "../../../state/tree-browser-state";

export type NodeWithHierarchy = Node & { bottomUpHierarchy?: BottomUpHierarchy<Node> };

export const TreeBrowserDomainNodeContext = React.createContext<TreeBrowserStateInterface<NodeWithHierarchy>>(null);
